import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFC107",
      light: "#FFD54F",
      dark: "#FFA000",
    },
    secondary: {
      main: "#1A1A1A",
    },
    background: {
      default: "#1A1A1A",
      paper: "#242424",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#FFC107",
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
  },
});

function App() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <Box id="hero">
          <Hero />
        </Box>
        <Box id="about">
          <About />
        </Box>
        <Box id="projects">
          <Projects />
        </Box>
        <Box id="contact">
          <Contact />
        </Box>
        <Footer />
      </ThemeProvider>
    );
  }

export default App;